import {Injectable} from '@angular/core';
import {Actions, createEffect, Effect, ofType} from '@ngrx/effects';

import {concatMap, map, switchMap} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';

import * as OrdersActions from './orders.actions';
import {OrdersService} from './orders.service';
import {
  createNewOrderFailed, createNewOrderSuccess,
  GetPreviousOrdersFailed,
  GetPreviousOrdersSuccess,
  GetSingleOrderFailed,
  GetSingleOrderSuccess, updateOrderFailed, updateOrderSuccess
} from './orders.actions';


@Injectable()
export class OrdersEffects {

  getSingleOrder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrdersActions.GetSingleOrder),
      switchMap(action => this.ordersService.getSingleOrder(action.id).pipe(map((res: any) => {
        if (res.code === 200) {
          return GetSingleOrderSuccess({order: res.data});
        }
        return GetSingleOrderFailed({error: res.data});
      })))
    );
  });
  getPreviousOrders$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrdersActions.GetPreviousOrders),
      switchMap(action => this.ordersService.getOrders().pipe(map((res: any) => {
        if (res.code === 200) {
          return GetPreviousOrdersSuccess({orders: res.data});
        }
        return GetPreviousOrdersFailed({error: 'Something Went Wrong!'});
      })))
    );
  });

  createNewOrder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrdersActions.createNewOrder),
      switchMap(action => this.ordersService.createNewOrder(action.order).pipe(map((res: any) => {
        if (res.code === 200) {
          return createNewOrderSuccess({order: res.data});
        }
        return createNewOrderFailed({errors: res.error});
      })))
    );
  });
  updateOrder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrdersActions.updateOrder),
      switchMap(action => this.ordersService.updateOrder(action.order).pipe(map((res: any) => {
        if (res.code === 200) {
          return updateOrderSuccess({order: res.data});
        }
        return updateOrderFailed({error: res.error});
      })))
    );
  });

  constructor(private actions$: Actions, private ordersService: OrdersService) {
  }

}
